import React from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import {
    RelatorioResultadoContatoController,
    RelatorioResultadoContatoExportExcelController,
} from "../../../Controllers/Cobranca/Relatorios/RelatoriosController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import Table from "../../../Components/Table";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import RelatoriosFilter from "./RelatoriosFiltro";
import { getXMonthsAgoDate } from "../../../Tools/DateTools";
import StorageManagerCapys from "../../../Tools/Storage";
import { ResultadoContatoRequest } from "../../../Interfaces/Relatorios/RelatoriosInterface";
import SpinnerComponent from "../../../Components/Loding/Spinner";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";

const filterStorage = new StorageManagerCapys<
    Omit<ResultadoContatoRequest, "NR_PAGINA">
>("FILTRO_GESTAO_COBRANCA_RELATORIOS");

function RelatoriosCobranca() {
    const todaysDate = new Date();

    const { PageFilter, setPage, setPageFilter, filter } = usePaginationFilter({
        page: 1,
        filter: {
            DT_FILTRO_INICIO: getXMonthsAgoDate(5).toISOString(),
            DT_FILTRO_FINAL: todaysDate.toISOString(),
        },
    });

    const { value: lstResultContato, loading: lstResultContatoLoading } =
        useAsyncEffect(async () => {
            const res = await RelatorioResultadoContatoController({
                ...PageFilter.filter,
                NR_PAGINA: PageFilter.page,
                DT_FILTRO_INICIO: PageFilter.filter?.DT_FILTRO_INICIO ?? "",
                DT_FILTRO_FINAL: PageFilter.filter?.DT_FILTRO_FINAL ?? "",
            });

            return res;
        }, [PageFilter]);

    const totalPaginas = lstResultContato?.[0]?.NR_PAGINAS || 1;

    const tableviewColumns: Array<ColumnDescription> = [
        {
            dataField: "DUMMY_FIELD",
            text: "",
            isDummyField: true,
        },
        {
            dataField: "ID_CASO",
            text: "Protocolo",
        },
        {
            dataField: "ID_CHAVE_ERP",
            text: "ID_CHAVE_ERP",
        },
        {
            dataField: "DS_NOME_ATENDENTE",
            text: "Responsável",
        },
        {
            dataField: "DS_HISTORICO",
            text: "Histórico",
        },
        {
            dataField: "DS_NOME",
            text: "Cliente",
        },
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Empreendimento",
        },
        {
            dataField: "DS_UNIDADE",
            text: "Unidade",
        },
        {
            dataField: "DS_MOTIVO_INADIMPLENCIA",
            text: "Motivo Inadimplencia",
        },
        {
            dataField: "DS_RESULTADO_CONTATO",
            text: "Resultado do Contato",
        },
        {
            dataField: "DS_CLASSIFICACAO_RESULTADO_CONTATO",
            text: "Classificação do Contato",
        },
        {
            dataField: "DT_FIM",
            text: "Data Atendimento",
            formatter: (c) => new Date(c).toLocaleString().substring(0, 10),
        },
        {
            dataField: "DT_CONTRATO",
            text: "Data de Contrato",
            formatter: (c) => new Date(c).toLocaleString().substring(0, 10),
        },
        {
            dataField: "DS_GRUPO",
            text: "Grupo",
        },
    ];

    return (
        <>
            <>
                <div className="card card-custom w-auto gutter-b m-5">
                    {lstResultContato ? (
                        <Table
                            columns={tableviewColumns}
                            data={lstResultContato}
                            keyField="ID_CASO"
                            onTableChange={(type, newState) => {
                                setPage(newState.page);
                            }}
                            remote={{ pagination: true }}
                            totalPages={totalPaginas}
                            loading={lstResultContatoLoading}
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhum Atendimento encontrado
                                </div>
                            )}
                            noHover
                            noSearch
                            bordered={false}
                            defaultStyle={{ align: "center" }}
                            striped={true}
                            rowClasses={"rowClasses"}
                            paginationColor={"Cobranca"}
                        />
                    ) : lstResultContatoLoading ? (
                        <SpinnerComponent />
                    ) : (
                        <div className="text-muted text-center">
                            Erro ao carregar dados
                        </div>
                    )}
                </div>
            </>
            <RelatoriosFilter
                handleSubmit={(formData) => {
                    setPageFilter({
                        filter: formData,
                        page: 1,
                    });
                }}
                storageManager={filterStorage}
                defaultFilter={filter}
            />
            <ExportExcel
                baixarExcelController={async () =>
                    RelatorioResultadoContatoExportExcelController(true, {
                        ...PageFilter.filter,
                        NR_PAGINA: 0,
                        DT_FILTRO_INICIO:
                            PageFilter.filter?.DT_FILTRO_INICIO ?? "",
                        DT_FILTRO_FINAL:
                            PageFilter.filter?.DT_FILTRO_FINAL ?? "",
                    })
                }
                nomeArquivo="Relatorio_Contrato_Cobranca"
            />
        </>
    );
}

export default RelatoriosCobranca;
